<template>
  <el-dialog v-adaptive title="企业微信绑定" :close-on-click-modal="false" :visible.sync="isShow" center @close="$emit('cancel')" width="520px" class="BindWeChat-dialog">
    <div class="BindingPage" v-loading="loaded">
      <el-form ref="ruleForm" :model="form" label-width="96px">
        <el-form-item label="当前用户：">
          <el-input size="medium" style="width: 376px" v-model="form.UserName" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号码：">
          <el-input size="medium" style="width: 376px" v-model="form.PhoneNumber"></el-input>
        </el-form-item>
        <el-form-item label="绑定状态：">
          <span :class="form.IsUserBindQywx ? 'binding' : 'unbounded'">
            {{ form.IsUserBindQywx ? '已绑定' : '未绑定' }}
          </span>
        </el-form-item>
      </el-form>
      <div>
        <div class="submit-button" v-if="form.IsUserBindQywx">
          <el-button size="medium" class="cancelWireless" @click="UnBidWeChat">解除绑定</el-button>
          <el-button size="medium" style="margin: 0 32px" type="primary" @click="bidWeChat" :loading="bidLoad">重新绑定</el-button>
          <el-button size="medium" type="primary" plain @click="bindWeChatTestShow = true">绑定测试</el-button>
        </div>
        <div class="submit-button" v-else>
          <el-button size="medium" type="primary" @click="bidWeChat" :loading="bidLoad">开始绑定</el-button>
        </div>
      </div>
    </div>
    <!-- 内层dialog -->
    <el-dialog v-adaptive append-to-body title="微信绑定测试" :close-on-click-modal="false" :visible.sync="bindWeChatTestShow" center width="520px" class="BindWeChatTest-dialog">
      <div class="BindWeChatTest">
        <bind-weChat-test :userName="form.UserName" />
      </div>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { GetUserWxidBindInfo, Bid, UnBid } from '../../http/api';
import BindWeChatTest from './BindWeChatTest.vue';
export default {
  name: 'BindWeChat',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  components: { BindWeChatTest },
  data() {
    return {
      loaded: true,
      bidLoad: false,
      bindWeChatTestShow: false,
      form: {
        UserName: '',
        PhoneNumber: '',
        IsUserBindQywx: false,
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loaded = true;
      GetUserWxidBindInfo().then((res) => {
        this.form = res;
        this.loaded = false;
      });
    },
    bidWeChat() {
      this.bidLoad = true;
      Bid({ phoneNumber: this.form.PhoneNumber })
        .then((res) => {
          this.init();
          this.$message.success('绑定成功！');
        })
        .finally(() => {
          this.bidLoad = false;
        });
    },
    UnBidWeChat() {
      UnBid().then((res) => {
        this.init();
        this.$message.success('解除绑定成功！');
      });
    },
  },
};
</script>
<style scoped>
.BindWeChatTest-dialog /deep/ .el-dialog__body,
.BindWeChat-dialog /deep/ .el-dialog__body {
  padding: 0;
}
.BindWeChatTest,
.BindingPage {
  margin: 0 16px;
  padding-top: 22px;
  padding-bottom: 32px;
}
.submit-button {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}
.unbounded {
  padding: 8px 16px;
  border-radius: 3px;
  color: rgba(255, 115, 115);
  background-color: rgba(255, 244, 244);
}
.binding {
  padding: 8px 16px;
  border-radius: 3px;
  color: rgba(33, 181, 82);
  background-color: rgba(240, 250, 243);
}
</style>
